import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Router } from "@angular/router";
import { ConfirmationService, MessageService } from "primeng/api";
import { Table } from "primeng/table";
import { ApiService } from "src/app/_services/api.service";
import { GlobalService } from "src/app/_services/global.service";


import jsPDF from 'jspdf';
import { applyPlugin  } from 'jspdf-autotable'

applyPlugin(jsPDF)

@Component({
  selector: 'app-table',
  templateUrl: './tb.component.html',
  styleUrls: ['./tb.component.css'],
  providers: [MessageService, ConfirmationService]
})
export class TbComponent implements OnInit {
  @Input() public pageTitle: string ='';
  @Input() public reportPdf: string ='';
  @Input() public newRecordUrl: string ='';
  @Input() public editRecordUrl: string ='';
  @Input() public settingsRecordUrl: string ='';
  @Input() public deleteRecordUrl: string ='';
  @Input() public listUrl: string='' ;
  @Input() public module: string ='';
  @Input() public listParams: any | undefined;
  @Input() public listFields: any | undefined;
  @Input() public dataList: any | undefined;

  
  @ViewChild('maintable') maintable:any;
  @ViewChild('filter') filter!: ElementRef;

 
  

  loading:boolean = true;

  constructor(
    private apiService: ApiService,
    public globalService : GlobalService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService, 
    public router: Router,
  ) { }

  ngOnInit(): void {  
    this.load();
    
  }
  load(){
    if(this.dataList){
       this.loading = false;
    } else {
      this.loading = true;
      this.apiService.post(this.listUrl,this.listParams).subscribe(data2 => {
        this.dataList=data2.Result;
        this.dataList=[...this.dataList];
        this.loading = false;
      });
    }
   
  }
  onGlobalFilter(table: Table, event: Event) {
      table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }
  
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
  
  clear(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  nuovoRecord(){
    this.router.navigateByUrl(this.newRecordUrl);
  }

  edit(record:any){
    
    this.router.navigateByUrl(this.editRecordUrl+record.id);
  }

  delete(record:any){
    let msg='Si conferma la cancellazione del record?';
    if(this.deleteRecordUrl=="mensa/programma_delete"){
      msg="Attenziona si conferma la cancellazione del programma?. L'operazione sarà irreversibile.";
    }
    this.confirmationService.confirm({
        message: msg,
        header: 'Conferma',
        closeOnEscape: true,
        icon: 'pi pi-exclamation-triangle',
        rejectLabel:'Annulla',
        acceptLabel:'Conferma',
        accept: () => {
           this.loading = false;
          this.messageService.add({ severity: 'warning', summary: 'ELiminato', detail: 'Record cancellato' });
          this.apiService.post(this.deleteRecordUrl,{id:record.id}).subscribe(data2 => {
             window.location.reload();
          });
          
        },
        reject: () => {
           
        },
    });
 
  }

  settings(record:any){
    this.router.navigateByUrl(this.settingsRecordUrl+record.id);
  }

  printPdf(){
    let doc: any = new jsPDF("l", "mm", "a4");
    let cols:any[]=[];
    let data:any[]=[];
    this.listFields.forEach((f)=>{
      cols.push(f['header']);
    });
  
    this.dataList.forEach((r)=>{
      let row=[];
      this.listFields.forEach((f)=>{
        row.push(r[f['field']]);
      });
      data.push(row);
    });
    let startY=0;
    doc.text(this.reportPdf, 10, startY + 6);
    startY+=6;
    doc.autoTable({
      head: [cols],
      body: data,
      startX:10,
      startY: startY + 2,
      margin: { horizontal: 10 },
      styles: { 
        overflow: "linebreak"
      },
      bodyStyles: { valign: "top" },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [30, 30, 30],
      },
      columnStyles: { email: { columnWidth: "wrap" } },
      theme: "striped",
      showHead: "everyPage" }
    );
    startY=doc.lastAutoTable.finalY;

    doc.save(this.reportPdf+'.pdf');
    
    
  }

  
}


